import { useTranslation } from 'react-i18next';
import SubscriptionDetails from './_SubscriptionDetails/SubscriptionDetails';
import { Box, Typography, Grid } from 'bonfire-kindling';

const SubscriptionInfo = props => {
  const { t } = useTranslation();

  return (
    <>
      <Box mb={4}>
        <Typography variant="h1" component="h2">
          {t('settings.subscription.title')}
        </Typography>
      </Box>
      <Grid item sm={12} md={9} lg={6}>
        <SubscriptionDetails {...props} />
      </Grid>
    </>
  );
};

export default SubscriptionInfo;
